<template>
  <div class="products">
    <a-row>
      <a-col class="productLineTitle">
        <h3>Hearing Protection</h3>
        <span>Product Lines</span>
      </a-col>
    </a-row>

    <a-row>
      <a-col>
        <router-link to="/category/foam_ear_plugs">
          <div class="proCategory banner1">
            <div class="imageOverlay"></div>
            <div class="textOverlay"><span>Foam Ear Plugs</span></div>
          </div>
        </router-link>
      </a-col>
      <a-col>
        <router-link to="/category/silicone_ear_plugs">
          <div class="proCategory banner2">
            <div class="imageOverlay"></div>
            <div class="textOverlay"><span>Silicone Ear Plugs</span></div>
          </div>
        </router-link>
      </a-col>
      <a-col>
        <router-link to="/category/filter_ear_plugs">
          <div class="proCategory banner3">
            <div class="imageOverlay"></div>
            <div class="textOverlay"><span>Filter Ear Plugs</span></div>
          </div>
        </router-link>
      </a-col>
      <a-col>
        <router-link to="/category/moldable_ear_plugs">
          <div class="proCategory banner4">
            <div class="imageOverlay"></div>
            <div class="textOverlay">
              <span>Custom Moldable Ear Plugs</span>
            </div>
          </div>
        </router-link>
      </a-col>
      <a-col>
        <router-link to="/category/passive_noise_reduction_ear_muffs">
          <div class="proCategory banner5">
            <div class="imageOverlay"></div>
            <div class="textOverlay"><span>Ear Muffs</span></div>
          </div>
        </router-link>
      </a-col>
      <a-col>
        <router-link to="/category/electronic_ear_muffs">
          <div class="proCategory banner6">
            <div class="imageOverlay"></div>
            <div class="textOverlay"><span>Electronic Ear Muffs</span></div>
          </div>
        </router-link>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Products",
  metaInfo: {
    title: "Products"
  },
  methods: {
    // callback ( key ) {
    //   console.log(key);
    // }
  }
};
</script>

<style lang="scss">
.products {
  margin: 35px 12.5%;

  .productLineTitle {
    margin-bottom: 2em;
    h3 {
      margin-bottom: 0;
      font-size: 36px;
      font-weight: bold;
      line-height: 42px;
    }
    span {
      font-weight: 300;
      font-size: 24px;
      line-height: 28px;
    }
  }

  .proCategory {
    transition: all 0.5s ease;
    &:hover {
      transform: translateY(-5px);
    }
    .imageOverlay {
      width: 100%;
      padding-top: 21%;
      background: grey;
      box-shadow: -1px 4px 20px rgba(0, 0, 0, 0.25);
      border-radius: 15px;
      z-index: 100;
      @media (max-width: 768px) {
        padding-top: 30%;
      }
    }
    .textOverlay {
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      font-size: 24px;
      line-height: 28px;
      height: 3em;
      position: relative;
      top: -1em;
      z-index: -100;
      @media (max-width: 768px) {
        font-size: 21px;
        line-height: 24px;
      }
      span {
        display: block;
        width: 100%;
        color: white;
        text-align: center;
        position: absolute;
        bottom: 0.5em;
      }
    }

    &.banner1 {
      .imageOverlay {
        background: url("https://img.cnsian.com/images/936f29f17f28bb3d292a25f6f476fd57.jpg")
          no-repeat;
        background-size: 100% 100%;
      }
      .textOverlay {
        background: linear-gradient(90deg, #f37335 0%, #fdc880 100%);
      }
    }
    &.banner2 {
      .imageOverlay {
        background: url("https://img.cnsian.com/images/df6947031710df441e14f3e4b90066d2.jpg")
          no-repeat;
        background-size: 100% 100%;
      }
      .textOverlay {
        background: linear-gradient(90deg, #00c9bf 0%, #00d1ff 100%);
        box-shadow: -1px 4px 20px rgba(0, 0, 0, 0.25);
      }
    }
    &.banner3 {
      .imageOverlay {
        background: url("https://img.cnsian.com/images/aee23517496d1f903ab40321d9983297.jpg")
          no-repeat;
        background-size: 100% 100%;
      }
      .textOverlay {
        background: linear-gradient(90deg, #16bffd 0%, #cb3066 100%);
      }
    }
    &.banner4 {
      .imageOverlay {
        background: url("https://img.cnsian.com/images/0f2d955253fd5e49a9980548b3ce06b8.jpg")
          no-repeat;
        background-size: 100% 100%;
      }
      .textOverlay {
        background: linear-gradient(90deg, #8e9eab 0%, #eef2f3 100%);
      }
    }
    &.banner5 {
      .imageOverlay {
        background: url("https://img.cnsian.com/images/0aea0050bd8c5e4fa4263c92976c1f1f.jpg")
          no-repeat;
        background-size: 100% 100%;
      }
      .textOverlay {
        background: linear-gradient(
          90deg,
          #7f7fd5 0%,
          #86a8e7 50%,
          #91eae4 100%
        );
      }
    }
    &.banner6 {
      .imageOverlay {
        background: url("https://img.cnsian.com/images/ec70da62f211c999b0e33e227df1a015.jpg")
          no-repeat;
        background-size: 100% 100%;
      }
      .textOverlay {
        background: linear-gradient(90deg, #000000 0%, #0f9b0f 100%);
      }
    }
  }
}
</style>
